import { connect } from 'react-redux';
import { getPage } from './selectors';
import * as actions from './actions';
import LinkManagement from './page';

const mapDispatchToProps = dispatch => {
    return {
        onAppSelected: (...args) => {
            dispatch(actions.selectApp(...args));
        },
        onAppFilterChanged: (...args) => {
            dispatch(actions.changeAppsFilter(...args));
        },
        onExpandClick: (...args) => {
            dispatch(actions.partnerExpandClick(...args));
        },
        onViewClick: (linkId, isLegacyLink) => {
            dispatch(actions.linkClicked(linkId, true, isLegacyLink));
        },
        onEditClick: (linkId, isLegacyLink) => {
            dispatch(actions.linkClicked(linkId, false, isLegacyLink));
        },
        onDuplicateClicked: linkId => {
            dispatch(actions.linkClicked(linkId, false, false, true));
        },
        onArchiveClicked: (...args) => {
            dispatch(actions.archiveClicked(...args));
        },
        onCreateLinkClicked: () => {
            dispatch(actions.createLinkClicked());
        },
        onCloseShelf: (...args) => {
            dispatch(actions.closeShelf(...args));
        },
        onTopButtonClicked: (...args) => {
            dispatch(actions.topButtonClicked(...args));
        },
        onEmptyStateAction: (actionName, ...args) => {
            if (!actions[actionName]) {
                return;
            }
            dispatch(actions[actionName](...args));
        },
        onToggleTabChanged: (...args) => {
            dispatch(actions.toggleTabChanged(...args));
        },
    };
};

export default connect(state => getPage(state), mapDispatchToProps)(LinkManagement);
